// utility functions for URL slug generation
import { getCountryFromPhone } from '../services/mappingService';
import { SITE_URL } from '../config/domain';

export const createEscortSlug = (name: string): string => {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim()
    .replace(/^-+|-+$/g, '');
};

// Telefono canonico = solo cifre. Il paese sta già nel path (/it/, /ch/),
// quindi via '+', spazi, '%2B', '00' e il prefisso '39' italiano.
// Il '41' svizzero resta come cifre (es. '+4179...' -> '4179...').
// ponytail: regola ingenua su lunghezza (39 + 10 cifre). Se arrivano formati
// strani, allargare qui — un solo punto di normalizzazione.
export const normalizePhone = (phone: string): string => {
  let digits = (phone || '').replace(/\D/g, '');
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (/^39\d{10}$/.test(digits)) digits = digits.slice(2);
  return digits;
};

export const createEscortUrl = (escort: { phone?: string; name: string; location: string }, countryCodeOverride?: string, absolute?: boolean): string => {
  const slug = createEscortSlug(escort.name);
  const rawPhone = (escort.phone || '').trim();

  // Country dal telefono raw: getCountryFromPhone riconosce '+41'/'0041',
  // che la normalizzazione a cifre rimuove. Calcolare prima, normalizzare dopo.
  const countryCode = countryCodeOverride || getCountryFromPhone(rawPhone);
  const phone = normalizePhone(rawPhone);

  const path = `/${countryCode}/escort/${phone}/${slug}`;
  return absolute ? `${SITE_URL}${path}` : path;
};

export const parseEscortSlug = (slug: string): { name: string; city: string } => {
  // For parsing, we need to be smarter about where the name ends and city begins
  // We'll use a simple heuristic: if the slug contains common Italian city patterns,
  // we can identify them better

  const parts = slug.split('-');
  if (parts.length < 2) {
    return { name: '', city: '' };
  }

  // Common patterns for Italian locations
  const locationPatterns = [
    'marche', 'roma', 'milano', 'napoli', 'torino', 'firenze', 'bologna',
    'venezia', 'bari', 'catania', 'verona', 'messina', 'padova', 'trieste'
  ];

  // Look for location patterns in the slug
  let nameEndIndex = parts.length - 1; // Default: everything except last part is name

  // Check if we have a compound location (like civitanova-marche)
  for (let i = parts.length - 1; i >= 1; i--) {
    const possibleLocation = parts.slice(i - 1).join(' ');
    if (possibleLocation.includes('civitanova marche') ||
        possibleLocation.includes('roma') ||
        locationPatterns.some(pattern => possibleLocation.includes(pattern))) {
      nameEndIndex = i - 1;
      break;
    }
  }

  // If we couldn't find a pattern, use simple split (name = all but last, city = last)
  const name = parts.slice(0, nameEndIndex).join(' ');
  const city = parts.slice(nameEndIndex).join(' ');

  return { name, city };
};

export const findEscortByPhone = (escorts: Array<any>, phone: string): any => {
  const wanted = normalizePhone(phone);
  if (!wanted) return undefined;
  return escorts.find(escort => normalizePhone(escort.phone) === wanted || (escort.pphone && normalizePhone(escort.pphone) === wanted));
};

export const createReviewsUrl = (escort: { phone?: string; name: string; location: string }, countryCodeOverride?: string, absolute?: boolean): string => {
  const slug = createEscortSlug(escort.name);
  const rawPhone = (escort.phone || '').trim();
  const countryCode = countryCodeOverride || getCountryFromPhone(rawPhone);
  const phone = normalizePhone(rawPhone);
  const path = `/${countryCode}/recensioni/${phone}/${slug}`;
  return absolute ? `${SITE_URL}${path}` : path;
};

